module.exports = __webpack_public_path__ + "img/MentorBadge_800x500.a77463c5.jpg";